import React from "react";
import { useTranslation } from "react-i18next";

import { FlashscanResult } from "@/types/Flashscan";
import { FlashscanKPICard } from "@/components/FlashscanKPICard/FlashscanKPICard";
import "./FlashscanKPI.scss";

type FlashscanKPIProps = {
  flashscanResult: FlashscanResult;
};

export const FlashscanKPI: React.FC<FlashscanKPIProps> = ({
  flashscanResult: latest,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flashscan-kpi">
      <FlashscanKPICard
        label={t("pages.flashscan.kpis.anomaliesDetected")}
        value={latest.anomaliesDetectedCount}
      />

      <FlashscanKPICard
        label={t("pages.flashscan.kpis.transactionsScanned")}
        value={latest.transactionsScannedCount.toLocaleString("fr-FR")}
        subvalue={`${latest.totalSalesAmountAnalyzed.toLocaleString("fr-FR")} €`}
      />

      <FlashscanKPICard
        label={t("pages.flashscan.kpis.recoverableRevenue")}
        value={`${latest.savedAmount.toLocaleString("fr-FR")} €`}
        variant="highlight"
      />
    </div>
  );
};
